// src/components/marketing/LeadFiltros.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const STATUS_OPTIONS = [
    { value: 'novo',       label: '🆕 Novo' },
    { value: 'contatado',  label: '📞 Contatado' },
    { value: 'convertido', label: '✅ Convertido' },
    { value: 'perdido',    label: '❌ Perdido' },
];

const PRIORIDADE_OPTIONS = [
    { value: 'baixa',   label: '🟢 Baixa' },
    { value: 'media',   label: '🟡 Média' },
    { value: 'alta',    label: '🟠 Alta' },
    { value: 'urgente', label: '🔴 Urgente' },
];

const LeadFiltros = ({ filtros, onChange, onLimpar, totalAtivo, colaboradores = [] }) => {
    const [aberto, setAberto] = useState(false);

    const handleChange = (campo, valor) => {
        onChange({ ...filtros, [campo]: valor });
    };

    const inputStyle = {
        padding: '6px 10px',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        fontSize: 'calc(13px * var(--font-scale))',
        color: '#374151',
        backgroundColor: '#fff',
        outline: 'none',
        width: '100%',
    };

    const labelStyle = {
        fontSize: 'calc(11px * var(--font-scale))',
        fontWeight: '600',
        color: '#6b7280',
        marginBottom: '4px',
        display: 'block',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    };

    return (
        <div style={{ position: 'relative' }}>
            {/* Botão toggle */}
            <button
                onClick={() => setAberto(prev => !prev)}
                style={{
                    padding: '6px 12px',
                    backgroundColor: totalAtivo > 0 ? '#eff6ff' : '#f9fafb',
                    border: `1px solid ${totalAtivo > 0 ? '#bfdbfe' : '#e5e7eb'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: 'calc(13px * var(--font-scale))',
                    fontWeight: '500',
                    color: totalAtivo > 0 ? '#2563eb' : '#6b7280',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    transition: 'all 0.15s',
                    whiteSpace: 'nowrap',
                }}
            >
                <FontAwesomeIcon icon="filter" />
                Filtros
                {totalAtivo > 0 && (
                    <span style={{
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        borderRadius: '999px',
                        padding: '0 6px',
                        fontSize: 'calc(10px * var(--font-scale))',
                        fontWeight: '700',
                        minWidth: '18px',
                        textAlign: 'center',
                    }}>
                        {totalAtivo}
                    </span>
                )}
            </button>

            {/* Painel */}
            {aberto && (
                <>
                    {/* Overlay para fechar clicando fora */}
                    <div
                        style={{ position: 'fixed', inset: 0, zIndex: 199 }}
                        onClick={() => setAberto(false)}
                    />

                    <div style={{
                        position: 'absolute',
                        top: '44px',
                        right: 0,
                        zIndex: 200,
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
                        padding: '20px',
                        width: '480px',
                        maxHeight: '80vh',
                        overflowY: 'auto',
                    }}>
                        {/* Header do painel */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px',
                            paddingBottom: '12px',
                            borderBottom: '1px solid #f3f4f6',
                        }}>
                            <span style={{
                                fontWeight: '700',
                                fontSize: 'calc(14px * var(--font-scale))',
                                color: '#111827',
                            }}>
                                Filtros avançados
                            </span>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                {totalAtivo > 0 && (
                                    <button
                                        onClick={() => { onLimpar(); setAberto(false); }}
                                        style={{
                                            padding: '4px 10px',
                                            backgroundColor: '#fee2e2',
                                            color: '#dc2626',
                                            border: 'none',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            fontSize: 'calc(12px * var(--font-scale))',
                                            fontWeight: '600',
                                        }}
                                    >
                                        Limpar tudo
                                    </button>
                                )}
                                <button
                                    onClick={() => setAberto(false)}
                                    style={{
                                        width: '28px', height: '28px',
                                        backgroundColor: '#f3f4f6',
                                        border: 'none', borderRadius: '6px',
                                        cursor: 'pointer', color: '#6b7280',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}
                                >
                                    <FontAwesomeIcon icon="times" />
                                </button>
                            </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

                            {/* ── Atendente ── */}
                            <div style={{ gridColumn: '1 / -1' }}>
                                <label style={labelStyle}>👤 Atendente responsável</label>
                                <div style={{ position: 'relative' }}>
                                    <FontAwesomeIcon icon="user" style={{
                                        position: 'absolute', left: '10px', top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#9ca3af', fontSize: 'calc(12px * var(--font-scale))',
                                        pointerEvents: 'none',
                                    }} />
                                    <select
                                        value={filtros.responsavel_id || ''}
                                        onChange={e => handleChange('responsavel_id', e.target.value)}
                                        style={{
                                            ...inputStyle,
                                            paddingLeft: '30px',
                                            appearance: 'none',
                                            cursor: 'pointer',
                                            color: filtros.responsavel_id ? '#374151' : '#9ca3af',
                                        }}
                                    >
                                        <option value="">Todos os atendentes</option>
                                        {colaboradores.map(c => (
                                            <option key={c.id} value={c.id}>{c.nome}</option>
                                        ))}
                                    </select>
                                    <FontAwesomeIcon icon="chevron-down" style={{
                                        position: 'absolute', right: '10px', top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#9ca3af', fontSize: 'calc(10px * var(--font-scale))',
                                        pointerEvents: 'none',
                                    }} />
                                </div>
                            </div>

                            {/* ── Status ── */}
                            <div>
                                <label style={labelStyle}>📊 Status</label>
                                <select
                                    value={filtros.status || ''}
                                    onChange={e => handleChange('status', e.target.value)}
                                    style={{ ...inputStyle, appearance: 'none', cursor: 'pointer' }}
                                >
                                    <option value="">Todos</option>
                                    {STATUS_OPTIONS.map(o => (
                                        <option key={o.value} value={o.value}>{o.label}</option>
                                    ))}
                                </select>
                            </div>

                            {/* ── Prioridade ── */}
                            <div>
                                <label style={labelStyle}>🔥 Prioridade</label>
                                <select
                                    value={filtros.prioridade || ''}
                                    onChange={e => handleChange('prioridade', e.target.value)}
                                    style={{ ...inputStyle, appearance: 'none', cursor: 'pointer' }}
                                >
                                    <option value="">Todas</option>
                                    {PRIORIDADE_OPTIONS.map(o => (
                                        <option key={o.value} value={o.value}>{o.label}</option>
                                    ))}
                                </select>
                            </div>

                            {/* ── Tag ── */}
                            <div style={{ gridColumn: '1 / -1' }}>
                                <label style={labelStyle}>🏷️ Tag</label>
                                <input
                                    type="text"
                                    placeholder="Filtrar por tag..."
                                    value={filtros.tag || ''}
                                    onChange={e => handleChange('tag', e.target.value)}
                                    style={inputStyle}
                                />
                            </div>

                            {/* ── Motivo da perda ── */}
                            <div style={{ gridColumn: '1 / -1' }}>
                                <label style={labelStyle}>❌ Motivo da perda</label>
                                <input
                                    type="text"
                                    placeholder="Filtrar por motivo da perda..."
                                    value={filtros.perdido_motivo || ''}
                                    onChange={e => handleChange('perdido_motivo', e.target.value)}
                                    style={inputStyle}
                                />
                            </div>

                            {/* ── Data de criação ── */}
                            <div>
                                <label style={labelStyle}>📅 Criação — De</label>
                                <input
                                    type="date"
                                    value={filtros.criado_de || ''}
                                    onChange={e => handleChange('criado_de', e.target.value)}
                                    style={inputStyle}
                                />
                            </div>
                            <div>
                                <label style={labelStyle}>📅 Criação — Até</label>
                                <input
                                    type="date"
                                    value={filtros.criado_ate || ''}
                                    onChange={e => handleChange('criado_ate', e.target.value)}
                                    style={inputStyle}
                                />
                            </div>

                        </div>

                        {/* Botão fechar/aplicar */}
                        <div style={{
                            marginTop: '16px',
                            paddingTop: '12px',
                            borderTop: '1px solid #f3f4f6',
                        }}>
                            <button
                                onClick={() => setAberto(false)}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: 'calc(13px * var(--font-scale))',
                                    fontWeight: '600',
                                }}
                            >
                                Aplicar filtros
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LeadFiltros;
